/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @enum {string}
 */

export const PaymentType = {
  SquareLegacy: "SQUARE_LEGACY",
  BankTransfer: "BANK_TRANSFER",
  Check: "CHECK",
  Other: "OTHER",
  Cash: "CASH",
  Balance: "BALANCE",
  Stripe: "STRIPE",
} as const;

export type PaymentType = (typeof PaymentType)[keyof typeof PaymentType];

export type PaymentTypeEnumType = typeof PaymentType;
export type PaymentTypeOptional = PaymentType;
export type PaymentTypeTrackedI = PaymentType;
export type PaymentTypeTracked = PaymentType;
export type PaymentTypeMetaI = EnumMetaType<PaymentTypeEnumType, PaymentType>;
export const PaymentTypeMeta = typeMetaEnum<PaymentTypeEnumType, PaymentType>(
  "PaymentType",
  PaymentType,
);
export function transformDatesPaymentType(model: PaymentType) {}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
